export const LANDING = '/';
export const PRIVACY_POLICY = '/privacy-policy';
export const TERMS = '/terms';
